export default __webpack_public_path__ + "static/media/sk.8449609c.svg";